export default "__VITE_ASSET__ea259a07__"